import React from "react";
import { createGlobalStyle, ThemeProvider, css } from 'styled-components';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const theme = {
  colors: {
    fg: "#fff",
    bg: "#DB3D2A",//red
    bg2: "#0077A1"//blue
  },
  fonts: {
    primary: "'Montserrat', 'Verdana', sans-serif;"
  },
  lang:'de',
  fontSizes: {
    small: "1.3em",
    medium: "1.7em",
    large: "2.1em",
    smallDesktop: "2em",
    mediumDesktop: "3em",
    largeDesktop: "3.85em"
  },
  breaks: {
    mobile: 780,
    tablet: 800
  },
  widthConcept: css`
    margin: 0 auto;
    width: 81%;
    @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
      width: 95%;
    }
    @media (max-width: ${props => (props.theme.breaks.tablet)}px) and (min-width: ${props => (props.theme.breaks.mobile+1)}px) {
      width: 90%;
    }
  `,
  shadow: css`
  -webkit-box-shadow: 4px 4px 4px 0px rgba(0,0,0,0.23);
  -moz-box-shadow: 4px 4px 4px 0px rgba(0,0,0,0.23);
  box-shadow: 4px 4px 4px 0px rgba(0,0,0,0.23);
  `
};

const GlobalStyle = createGlobalStyle`  
  body {
    color: ${theme.colors.fg};
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontSizes.smallDesktop};
    text-align: center;
    /*font-weight: bold;*/
    @media (max-width: ${theme.breaks.mobile}px) {
      font-size: ${theme.fontSizes.small};
    }
    line-height: 1.3em;
    margin: 0;
    width: 100%;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: linear-gradient(to right, ${theme.colors.bg2} 50%, ${theme.colors.bg} 50%);
  }
  a {
    text-decoration: none;
    color: ${theme.colors.fg};
  }
`

const Theme = ({ children }) => (
  <HelmetProvider>
    <ThemeProvider theme={theme}>
      <Helmet>
        {process.env.NODE_ENV === 'production' &&
          <link rel="stylesheet" type="text/css" href="./static/fonts/montserrat/montserrat.css" />
        }

      </Helmet>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  </HelmetProvider>
);

export default Theme;
